<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">บันทึกข้อมูลเรียบร้อย !</v-alert>
        <v-alert type="success" class="alert" v-if="alert_tracking === true">เปลี่ยนสถานะเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <v-card elevation="6">
        <div class="ma-4">
          <div class="pa-3 text-right">
            <router-link to="/sell/createorderother">
              <v-btn x-large class="grad-success-bg white--text btn_mobile" style="font-size: 18px">สร้างคำสั่งซื้อใหม่</v-btn>
            </router-link>
          </div>
          <div class="pa-3 pt-5">
            <v-divider/>
            <v-tabs grow show-arrows v-model="tab_menu" color="#8cc63e" v-if="loading_data === true">
              <v-tab  style="font-size: 18px" disabled>คำสั่งกำลังดำเนินการ</v-tab>
              <v-tab  style="font-size: 18px" disabled>เสร็จสิ้น</v-tab>
            </v-tabs>
            <v-tabs grow show-arrows v-model="tab_menu" color="#8cc63e" v-else>
              <v-tab  style="font-size: 18px">คำสั่งกำลังดำเนินการ</v-tab>
              <v-tab  style="font-size: 18px">เสร็จสิ้น</v-tab>
            </v-tabs>
            <v-divider/>
          </div>
          <div class="pa-3">
            <div v-if="loading_data === true">
              <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
              </v-sheet>
            </div>
            <div v-else>
              <v-data-table :headers="headers" :items="data_list" :footer-props="footer_Props" mobile-breakpoint="0">
                <template slot="item" slot-scope="dataDetail">
                  <tr>
                    <td>{{ dataDetail.item.order_code }}</td>
                    <td>{{ dataDetail.item.receipt_code  || '-'}}</td>
                    <td>{{ dataDetail.item.customer_name }}</td>
                    <td>
                      <div v-if="dataDetail.item.order_status === 0">
                        <div style="color: #8cc63e">{{ format_price(dataDetail.item.total) }}</div>
                      </div>
                      <div v-else-if="dataDetail.item.order_status === 1">
                        <div style="color: #fdac39">{{ format_price(dataDetail.item.total) }}</div>
                      </div>
                      <div v-if="dataDetail.item.order_status === 2">
                        <div style="color: red">{{ format_price(dataDetail.item.total) }}</div>
                      </div>
                      <div v-if="dataDetail.item.order_status === 3">
                        <div style="color: #8cc63e">{{ format_price(dataDetail.item.total) }}</div>
                      </div>
                    </td>
                    <td>{{ dataDetail.item.created_at }}</td>
                    <td v-if="title_type === 0">
                      <div v-if="dataDetail.item.order_status === 0">
                        <div style="color: #8cc63e">คำสั่งซื้อใหม่</div>
                      </div>
                      <div v-else-if="dataDetail.item.order_status === 1">
                        <div style="color: #fdac39">ดำเนินการจัดสินค้า</div>
                      </div>
                    </td>
                    <td v-else>
                      <div v-if="dataDetail.item.order_status === 3 && dataDetail.item.delivery_type === 0">รับหน้าร้าน</div>
                      <div v-else-if="dataDetail.item.order_status === 3 && dataDetail.item.delivery_type === 1" style="color: grey">แทร็กกิ้ง : {{ dataDetail.item.tracking_number }}</div>
                      <div v-else style="color: red">ยกเลิก : {{ dataDetail.item.cancel_note }}</div>
                    </td>
                    <td class="pa-3">
                      <div v-if="dataDetail.item.order_status === 0">
                        <v-btn small height="42" class="grad-success-bg white--text mr-1 mb-1" @click="get_detail(dataDetail.item.id)" title="รายละเอียด">
                          <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                      </div>
                      <div v-else-if="dataDetail.item.order_status === 1">
                        <v-btn small height="42" class="grad-success-bg white--text mr-1 mb-1" @click="get_detail(dataDetail.item.id)" title="รายละเอียด">
                          <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        <v-btn v-if="dataDetail.item.delivery_type === 1" small @click="tracking_modal(dataDetail.item.id,dataDetail.item.count_product_not_have_in_warehouse)" height="42" class="grad-warning-bg white--text mr-1 mb-1" style="font-size: 18px">
                          ส่งแล้ว
                        </v-btn>
                        <v-btn v-else small @click="confirm_modal(dataDetail.item.id,dataDetail.item.count_product_not_have_in_warehouse)" height="42" class="grad-warning-bg white--text mr-1 mb-1" style="font-size: 18px">
                          ส่งแล้ว
                        </v-btn>
                      </div>
                      <div v-else-if="dataDetail.item.order_status === 2">
                        <v-btn small height="42" class="grad-success-bg white--text mr-1 mb-1" @click="get_detail(dataDetail.item.id)" title="รายละเอียด">
                          <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                      </div>
                      <div v-else-if="dataDetail.item.order_status === 3">
                        <v-btn small height="42" class="grad-success-bg white--text mr-1 mb-1" @click="get_detail(dataDetail.item.id)" title="รายละเอียด">
                          <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                      </div>
                    </td>
                    <td class="pa-3">
                      <v-btn small height="42" class="grad-main-bg white--text ml-1 mb-1" @click="print_send_order(dataDetail.item.order_code, dataDetail.item.delivery_type)" title="พิมพ์ใบเสร็จ">
                        <v-icon>mdi-printer</v-icon> พิมพ์
                      </v-btn> 
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
        <v-dialog v-model="tracking_success" persistent max-width="900">
          <v-card class="rounded-xl">
            <v-form ref="update" @submit.prevent="wait_for_save">
              <div class="d-flex justify-space-between">
                <v-card-title>
                  เพิ่มหมายเลขแทร๊กกิ้ง
                </v-card-title>
                <v-btn icon class="ma-4" @click="close_modal">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <div class="ma-3 ml-1">
                  <v-text-field color="#86bc3a" clearable class="rounded-pill" type="text" label="กรุณากรอกหมายเลขแทร็กกิ้ง" :rules="[v => !!v || 'กรุณากรอกหมายเลขแทร็กกิ้ง']" prepend-inner-icon="mdi-truck-minus-outline" v-model="modal_track.tracking_number" hide-details="auto" outlined></v-text-field>
                </div>
              </v-card-text>
              <v-spacer></v-spacer>
              <div class="text-center pa-4">
                <v-btn large class="rounded-pill grad-success-bg white--text mr-3" type="submit" style="font-size: 18px">
                  ยืนยันหมายเลขแทร๊กกิ้ง
                </v-btn>
              </div>
            </v-form>
          </v-card>
        </v-dialog>
        <v-dialog v-model="tracking_save" persistent max-width="900">
          <v-card class="rounded-xl">
            <v-form ref="update" @submit.prevent="save_data">
              <div class="d-flex justify-space-between">
                <v-card-title>
                  ยืนยันการส่งสินค้า
                </v-card-title>
                <v-btn icon class="ma-4" @click="close_modal">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <div class="ma-3 ml-1">
                  คุณส่งสินค้าให้ลูกค้า ซึ่งต้องการรับที่หน้าร้านเรียบร้อยแล้วใช่ไหม ?
                </div>
              </v-card-text>
              <v-spacer></v-spacer>
              <div class="text-center pa-4">
                <v-btn large class="rounded-pill grad-success-bg white--text mr-3" type="submit" style="font-size: 18px">
                  ส่งสินค้าแล้ว
                </v-btn>
              </div>
            </v-form>
          </v-card>
        </v-dialog>
      </v-card>
      <v-overlay :value="overlay" class="z_index">
        <div style="text-align: center">
          <v-progress-circular
              indeterminate
              size="70"
              width="7"
              color="#86bc3a"
          ></v-progress-circular>
          <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
        </div>
      </v-overlay>
    </div>
  </div>
</template>

<script>

import {HTTP} from "@/axios";
import {formatPrice} from "@/js/handler";
import Swal from "sweetalert2";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Order_other_main",
  data() {
    return {
      loading_page: false,
      loading_data: false,
      tracking_success: false,
      tracking_save: false,
      alert_success: false,
      alert_tracking: false,
      overlay: false,
      title_type: 0,
      modal_track: {
        tracking_id: null,
        tracking_number: null,
      },
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      headers: [],
      data_list: [],
      tab_menu: 0,
    }
  },
  methods: {
    format_price: function (value) {
      return formatPrice(value)
    },
    page(type) {
      this.title_type = type
      if (this.title_type === 0) {
        this.headers = [
          {
            text: 'รหัสคำสั่งซื้อ',
            value: 'order_code',
            fixed: true,
            width: '200px',
          },
          {
            text: 'เลขใบกำกับภาษี',
            value: 'receipt_code',
            fixed: true,
            width: '300px',
          },
          {
            text: 'ลูกค้า',
            value: 'name',
            fixed: true,
            width: '300px',
          },
          {
            text: 'ยอดรวม',
            value: 'total',
            fixed: true,
            width: '200px',
          },
          {
            text: 'วันที่สั่งซื้อ',
            value: 'created_at',
            fixed: true,
            width: '150px',
          },
          {
            text: 'สถานะ',
            value: 'status',
            fixed: true,
            width: '250px',
          },
          {
            text: 'จัดการ',
            value: '',
            sortable: false,
            fixed: true,
            width: '180px',
          },
          {
            text: 'พิมพ์',
            value: '',
            sortable: false,
            fixed: true,
            width: '180px',
          },
        ]
        this.get_data()
      }
      if (this.title_type === 1) {
        this.headers = [
          {
            text: 'รหัสคำสั่งซื้อ',
            value: 'order_code',
            fixed: true,
            width: '200px',
          },
          {
            text: 'เลขใบกำกับภาษี',
            value: 'receipt_code',
            fixed: true,
            width: '300px',
          },
          {
            text: 'ลูกค้า',
            value: 'name',
            fixed: true,
            width: '300px',
          },
          {
            text: 'ยอดรวม',
            value: 'total',
            fixed: true,
            width: '200px',
          },
          {
            text: 'วันที่สั่งซื้อ',
            value: 'created_at',
            fixed: true,
            width: '150px',
          },
          {
            text: 'รายละเอียด',
            value: '',
            sortable: false,
            fixed: true,
            width: '250px',
          },
          {
            text: 'จัดการ',
            value: '',
            sortable: false,
            fixed: true,
            width: '180px',
          },
          {
            text: 'พิมพ์',
            value: '',
            sortable: false,
            fixed: true,
            width: '180px',
          },
        ]
        this.get_data()
      }
    },
    tracking_modal(id,count_product_not_have_in_warehouse) {
      if (count_product_not_have_in_warehouse == 0) {
        this.tracking_success = true
        this.modal_track.tracking_id = id   
      }

      if (count_product_not_have_in_warehouse != 0) {
        Swal.fire({
            title: "ไม่สามารถดำเนินการได้ !",
            text: 'สินค้าในคลังไม่เพียงพอ กรุณาตรวจสอบคำสั่งซื้อหรือนำสินค้าเข้าคลัง',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.tracking_success = false
          })
      }

    },
    get_data() {
      this.loading_data = true
      HTTP.post('/neworders/getall', {
        status: this.title_type
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_data = false
          this.data_list = res.data.object
        }
      })
    },
    get_detail(id) {
      this.$router.push('/sell/orderotherdetail/' + id)
    },
    cancel_detail(id) {
      this.$router.push('/sell/payincorrect/' + id)
    },
    wait_for_save() {
      if (this.$refs.update.validate()) {
        this.overlay = true
        HTTP.post('/neworders/updatetracking', {
          order_id: this.modal_track.tracking_id,
          tracking_number: this.modal_track.tracking_number,
        }).then((res) => {
          if (res.data.success === true) {
            this.overlay = false
            this.tracking_success = false
            this.tracking_save = false
            this.alert_success = true
            setTimeout(() => this.alert_success = false,3000)
            this.page(0)
          }
          else {
            this.overlay = false
            Swal.fire({
              title: res.data.message,
              icon: 'error',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
              denyButtonText: `ยกเลิก`,
            }).then(() => {
              this.tracking_success = false
              this.tracking_save = false
            })
          }
        })
      }
    },
    confirm_modal(id,count_product_not_have_in_warehouse) {
      if (count_product_not_have_in_warehouse == 0) {
        this.modal_track.tracking_id = id
        this.tracking_save = true        
      }

      if (count_product_not_have_in_warehouse != 0) {
        Swal.fire({
            title: "ไม่สามารถดำเนินการได้ !",
            text: 'สินค้าในคลังไม่เพียงพอ กรุณาตรวจสอบคำสั่งซื้อหรือนำสินค้าเข้าคลัง',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.tracking_save = false
          })
      }

    },
    save_data() {
      this.overlay = true
      HTTP.post('/neworders/updatetracking', {
        order_id: this.modal_track.tracking_id,
        tracking_number: 'รับที่ร้าน'
      }).then((res) => {
        if (res.data.success === true) {
          this.overlay = false
          this.tracking_success = false
          this.tracking_save = false
          this.alert_success = true
          setTimeout(() => this.alert_success = false,3000)
          this.page(0)
        }
        else {
          this.overlay = false
          Swal.fire({
            title: res.data.message,
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.tracking_success = false
            this.tracking_save = false
          })
        }
      })
    },
    close_modal() {
      this.tracking_success = false
      this.tracking_save = false
      this.modal_track.tracking_number = ''
    },
    print_send_order(order_code, delivery_type) {
      if (delivery_type !== 0) {
        window.open('https://www.pharmacare-plus.com/invoicepdfcreditpayadmin/' + order_code, '_blank')
        window.open('https://www.pharmacare-plus.com/packingslipadmin/' + order_code, '_blank')
        window.open('https://www.pharmacare-plus.com/envelopeadmin/' + order_code, '_blank')
      } else {
        window.open('https://www.pharmacare-plus.com/invoicepdfcreditpayadmin/' + order_code, '_blank')
        window.open('https://www.pharmacare-plus.com/packingslipadmin/' + order_code, '_blank')
      }
    },
  },
  mounted() {
    this.page(0)
  },
  watch:{
    tab_menu(){
      this.page(this.tab_menu)
    }
  }
}
</script>

<style scoped>
@media only screen and (max-width: 500px) {
  .btn_mobile {
    width: 100%;
  }
}
</style>
